import type { Tour } from '../../types';

export const mdaTour: Tour = {
  id: 'platform-mda',
  name: 'MDA Management Tour',
  description: 'Learn how to create and manage MDAs',
  category: 'platform',
  showProgress: true,
  requiredPath: '/platform/mdas',
  steps: [
    {
      id: 'mda-1',
      target: 'mda-header',
      title: 'MDA Management',
      content: 'Manage all Ministries, Departments, and Agencies from this central console. Each MDA has its own isolated data and user base.',
      position: 'bottom',
      spotlight: true,
    },
    {
      id: 'mda-2',
      target: 'mda-create-btn',
      title: 'Create New MDA',
      content: 'Click here to onboard a new institution. You\'ll provide basic information, assign an MDA code, and set up the initial admin user.',
      position: 'bottom',
      spotlight: true,
    },
    {
      id: 'mda-3',
      target: 'mda-search',
      title: 'Search MDAs',
      content: 'Quickly find an MDA by name, code, or region. Use filters to narrow down the list.',
      position: 'bottom',
      spotlight: true,
    },
    {
      id: 'mda-4',
      target: 'mda-list',
      title: 'MDA Directory',
      content: 'View all registered MDAs with their status, user count, and storage usage. Click any MDA for detailed management options.',
      position: 'right',
      spotlight: true,
    },
    {
      id: 'mda-5',
      target: 'mda-status-badge',
      title: 'MDA Status',
      content: 'Each MDA shows its operational status: Active, Suspended, or Pending Setup. Suspended MDAs cannot access the system.',
      position: 'left',
      spotlight: true,
    },
    {
      id: 'mda-6',
      target: 'mda-actions',
      title: 'Quick Actions',
      content: 'Access common actions for each MDA: view details, manage users, edit configuration, or suspend access.',
      position: 'left',
      spotlight: true,
    },
    {
      id: 'mda-7',
      target: 'mda-bulk-actions',
      title: 'Bulk Operations',
      content: 'Select multiple MDAs to perform bulk actions like exporting data, sending notifications, or applying policy updates.',
      position: 'bottom',
      spotlight: true,
      actionLabel: 'Finish Tour',
    },
  ],
};
